<!--
 * @Description: 根据 页面控制信息接口 返回状态控制显示当前组件显示  
 * @Author: 泰多
 * @LastEditors: 泰多
 * @Date: 2020-11-30 14:14:07
 * @LastEditTime: 2020-12-01 17:10:16
-->
<template>
    <div class="">
        <el-dialog
        class="tdGlobalHintLayer"
        :show-close="cp_isClose"
        :modal="true"
        :lock-scroll="false"
        :close-on-click-modal="cp_isClose"
        :title="dt_apiData.controlName || '提示'"
        :visible.sync="centerDialogVisible"
        width="40%"
        center>
        <span v-text="dt_apiData.content"></span>
        <img :src="dt_apiData.picSrc" />
        <span slot="footer" class="dialog-footer" v-if="cp_isClose">
            <el-button type="primary" @click="centerDialogVisible = false">知 道 了</el-button>
        </span>
        </el-dialog>
    </div>
</template>
<script>
import { axiosGetPageControlInfos } from '@/service/api.js'
export default {
    created() {
        this.init();
    },
    data() {
        return {
            centerDialogVisible: false,
            dt_apiData:{}
        }
    },
    computed: {
        cp_isClose() {
            return this.dt_apiData.allowClose == 1;
        }
    },
    watch: {
        centerDialogVisible(val){
            if (!val) {
                document.body.className = document.body.className.replace('el-popup-parent--hidden', '');
            }
        }
    },
    methods: {
        async init() {
           let {data, isOk} =  await axiosGetPageControlInfos();
           if (isOk && Array.isArray(data) && data.length) {
               this.centerDialogVisible = true;
               this.dt_apiData = data[0];
               this.$nextTick(() => {
                 setTimeout(() => {
                      document.body.scrollTop = document.documentElement.scrollTop = 0
                      document.body.className += " el-popup-parent--hidden";
                 }, 500)
               })
           } else {
               this.centerDialogVisible = false;
               this.dt_apiData = {};
           }
        }
    },
}
</script>
<style scoped lang="less">
    .tdGlobalHintLayer{
        span,img {
            line-height: 20px;
            display: block;
            margin:auto;
            text-align: center;
        }
    }
</style>